// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__3YGBP","gears":"about_gears__2inrR","pen":"about_pen__3OGgs","email":"about_email__3At7c","reactLogo":"about_reactLogo__25NXf"};